module.exports = __webpack_public_path__ + "assets/img/title-9f7645a8.png";